module.exports = __webpack_public_path__ + "de77a722/img/splash-icon.07a7c465.svg";